import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { BorderedIconButton } from "@src/appV2/components/BorderedIconButton";

interface StarProfessionalActionProps {
  isStarred: boolean;
  handleStarProfessional: () => void;
  disabled: boolean;
  visible: boolean;
}

export function StarProfessionalAction(props: StarProfessionalActionProps) {
  const { isStarred, handleStarProfessional, disabled, visible } = props;
  if (!visible) {
    return null;
  }

  return isStarred ? (
    <BorderedIconButton
      disabled={disabled}
      tooltip="Remove from starred"
      onClick={handleStarProfessional}
    >
      <StarIcon />
    </BorderedIconButton>
  ) : (
    <BorderedIconButton
      disabled={disabled}
      tooltip="Add to starred"
      onClick={handleStarProfessional}
    >
      <StarBorderIcon />
    </BorderedIconButton>
  );
}
